import { cxTheme } from 'components/storybook-migration/theme-provider/system-design/theme';
import { SPACING_2 } from 'constants/theme-constants';
import styled from 'styled-components';

export const SummaryCardTitleContainer = styled.div`
  ${({ theme }) => `
    display: flex;
    align-items: center;
    ${theme.label.medium.bold};
    margin-bottom: ${cxTheme.spacing[SPACING_2]};
`}
`;
